import type {RouteRecordRaw} from 'vue-router';
import {isApply, restTime} from "@/stores/question";
import {doMessage} from "@/utils/doMessage";
import {useFetch} from "@/hooks/useFetch";
import Api from "@/api";
import {questionStore} from "@/stores/question";
// import {storeToRefs} from "pinia";
import pinia from "@/stores";
import type {getQuestionType} from "@/types/api";
import type {Question} from "@/types/question-types";

const QuestionStore = questionStore(pinia);
const {initQuestionList, initAnswerList} = QuestionStore;

export const routesMobile: RouteRecordRaw[] = [{
    path: "/",
    redirect: '/home',
    component: () => import("@/mobile/Home.vue"),
    children: [{
        path: "/home",
        name: "Home",
        component: () => import("@/mobile/views/home/Home.vue"),
        beforeEnter(to, from, next) {
            document.title = "首页";
            next();
        },
        meta: {
            hideFooterLabel: true,
            hiddenUserName: true,
        },
    }, {
        path: "/recruitment",
        name: "Recruitment",
        component: () => import("@/mobile/views/recruitment/Home.vue"),
        beforeEnter(to, from, next) {
            document.title = "解决方案";
            next();
        },
    }, {
        path: "/consultation",
        name: "Consultation",
        component: () => import("@/mobile/views/consultation/Home.vue"),
        beforeEnter(to, from, next) {
            document.title = "合作咨询";
            next();
        },
    }, {
        path: "/report",
        name: "Report",
        component: () => import("@/mobile/views/report/Home.vue"),
        beforeEnter(to, from, next) {
            document.title = "大数据报告";
            next();
        },
    }, {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () => import("@/mobile/views/NotFound.vue"),
        beforeEnter(to, from, next) {
            document.title = "暂无该页面";
            next();
        },
        meta: {
            hideFooterLabel: true,
            hiddenUserName: true,
        },
    }]
}, {
    path: "/ac",
    component: () => import("@/mobile/views/ac/IndexView.vue"),
    children: [{
        path: "",
        name: "Attention",
        component: () => import("@/mobile/views/ac/HomeView.vue"),
        beforeEnter(to, from, next) {
            document.title = "百度心理测评";
            if (!localStorage.getItem("token")) {
                next('/ac/login');
                return;
            } else {
                (async () => {
                    const {run: getQuestion} = useFetch<
                        getQuestionType.Res,
                        getQuestionType.Req
                    >(Api.PsyAssessService.getQuestion);
                    const {errNo, data, message} = await getQuestion({
                        token: localStorage.getItem("token") as string,
                        userID: localStorage.getItem("userID") as string,
                    });
                    if (errNo === 0 && data) {
                        // 正常请求题目
                        localStorage.setItem("quizID", data.quizID);
                        const qs: Question[] = [];
                        let num = 0;
                        data.question.forEach((i) => {
                            qs.push({
                                id: num++,
                                label: i,
                                type: "radio",
                                options: [
                                    "A、完全不符",
                                    "B、不太符合",
                                    "C、基本符合",
                                    "D、比较符合",
                                    "E、完全符合",
                                ],
                            });
                        });
                        initQuestionList(qs);
                        initAnswerList(data.answerList as number[]);
                        next();
                        return;
                    } else if (errNo === -1 && message) {
                        // 已经完成作答
                        isApply.value = true;
                        restTime.value = true;
                        localStorage.setItem("isAnswered", "true");
                        localStorage.setItem("resMessage", message);
                        localStorage.setItem("isApply", "true");
                        localStorage.setItem("restTime", "true"); // 用户是否阅读完成阅读事项
                        // return {path: '/ac/question'};
                        // router.push("/ac/question");
                        next('/ac/question');
                        return;
                    } else if (errNo === -12 && message) {
                        doMessage("您已经在其他地方登陆，请重新登录", "info");
                        localStorage.clear();
                        // return {path: '/ac/login'};
                        next('/ac/login');
                        return;
                    }
                })();
                return;
            }
        },
    }, {
        path: "login",
        name: "Login",
        component: () => import("@/mobile/views/ac/LoginView.vue"),
        beforeEnter(to, from, next) {
            document.title = "百度心理测评用户登录";
            next();
        },
        meta: {
            hiddenUserName: true,
        }
    }, {
        path: "question",
        name: "Question",
        component: () => import("@/mobile/views/ac/QuestionView.vue"),
        beforeEnter(to, from, next) {
            document.title = "百度心理测评作答";
            if (!localStorage.getItem("token")) {
                doMessage("您还未登录，请先登录");
                // return {path: '/ac/login'};
                next('/ac/login');
                return;
            }
            if (
                localStorage.getItem("token")
                && (localStorage.getItem("isApply") !== "true"
                    || localStorage.getItem("restTime") !== "true")
            ) {
                doMessage(
                    "请同意保证书或阅读注意事项，页面正在跳转..."
                );
                // return {path: '/ac'};
                next('/ac');
                return;
            } else {
                // return;
                next();
            }
        },
    }, {
        path: "complete",
        name: "Complete",
        component: () => import("@/mobile/views/ac/CompleteView.vue"),
        beforeEnter(to, from, next) {
            document.title = "作答完成";
            next();
        },
    }, {
        path: "platformPolicy",
        name: "PlatformPolicy",
        component: () => import("@/mobile/views/ac/PlatformPolicyView.vue"),
        beforeEnter: (to, from, next) => {
            document.title = "百度人才智库平台用户协议";
            next();
        },
    }, {
        path: "/ac/:w+",
        name: "AcNotFound",
        component: () => import("@/mobile/views/NotFound.vue"),
        beforeEnter(to, from, next) {
            document.title = "暂无该页面";
            next();
        },
        meta: {
            hideFooterLabel: true,
            hiddenUserName: true,
        },
    }]
}];
